import { render, staticRenderFns } from "./FMWhatsApp.vue?vue&type=template&id=8c522136&scoped=true"
import script from "./FMWhatsApp.vue?vue&type=script&lang=js"
export * from "./FMWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./FMWhatsApp.vue?vue&type=style&index=0&id=8c522136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c522136",
  null
  
)

export default component.exports